const state = {
    basicList: [],
    followList: []
};

const mutations = {
    SET_BASIC_LIST(state, data) {
        state.basicList = data || [];
    },
    SET_FOLLOW_LIST(state, data) {
        state.followList = data || [];
    }
};

const actions = {
    setBasicList({commit}, data) {
        commit('SET_BASIC_LIST', data);
    },
    setFollowList({commit}, data) {
        commit('SET_FOLLOW_LIST', data);
    }
};

const getters = {
    basicList: state => state.basicList,
    followList: state => state.followList
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
